import { createContext } from "react";

export const messagesContext = createContext();
export const modalContext = createContext();
